<div class="container">
  <div class="row mt-5">
    <div class="col-12">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_245_1774)">
          <path d="M15.41 16.59L10.83 12L15.41 7.41L14 6L8 12L14 18L15.41 16.59Z" fill="#009DFF"/>
        </g>
        <defs>
          <clipPath id="clip0_245_1774">
            <rect width="24" height="24" fill="white"/>
          </clipPath>
        </defs>
      </svg>
      <label class="back" routerLink="/office/{{details.practiceId}}">Back</label>
    </div>
  </div> 
  <div class="row mt-5">
    <div class="col-12">
      <label class="main-header-text">Exclusive Dental Plan Savings - </label>
      <label class="plan-name-header-text mx-2"> {{em.selectedLevel.planName}}</label>
    </div>
  </div>
  <app-plan-summary 
    [planSummary]="details.salesPlanMarketingDetails?.planSummary" 
    [coverageLevel]="coverageLevel">
  </app-plan-summary>
  <app-plan-benefits 
    [planBenefits]="details.salesPlanMarketingDetails?.planBenefits"
    [ancillaryCodes]="template?.ancillaryBenefits || ''">
  </app-plan-benefits>
  <div class="row mt-5" *ngIf="details.salesPlanMarketingDetails?.commonDentalPlanSavings">
    <div class="col-12">
      <app-card-container>
        <div class="row">
          <div class="col-12">
            <div class="header-text">Common Dental Plan Savings</div>
          </div>
        </div>
        <div class="row mt-5 mb-3">
          <div class="col-4 table-title">ADA Code</div>
          <div class="col-4 table-title">Procedure Description</div>
          <div class="col-4 table-title">Member Pays*</div>
          <div class="col-12 border-gray mt-2"></div>
        </div>
        <div class="row mb-3" *ngFor="let item of details.salesPlanMarketingDetails?.commonDentalPlanSavings ; let ii = index ">
          <div *ngIf="item.itemName != 'Footer'">
            <div class="row">
              <div class="col-12 section-header mt-3 mb-2">{{item.itemName}}</div>
            </div>
            <div class="row mt-2" *ngFor="let items of item.value ; let a = index">
              <div class="col-4 mb-3">{{items.column1}}</div>
              <div class="col-4 mb-3">{{items.column2}}</div>
              <div class="col-4 mb-3">{{items.column3}}</div>
              <div class="col-12 border-gray"></div>
            </div>
          </div>
        </div>
        <div class="row mt-5 mb-3">
          <div class="col-12 col-lg-12 mb-3 sub-text2" *ngIf="footer != 'X%'">
            *Member savings may vary by location. Free exams and x-rays have no limitations. Any services not listed are available at a minimum of {{footer}} off the office’s Retail Fee(s).
          </div>
          <div class="col-12 col-lg-12 mb-3 sub-text">
            You are responsible for payment of the dentist’s normal fees for any of the following limited services:
          </div>
          <div class="col-12 col-lg-12 mb-3 sub-text2">
            Replacement of partial dentures is limited to one per arch every two years. <br>
            Replacement of full upper and lower dentures are limited to one per arch every two years. <br>
            Replacement of fixed prosthetics such as crowns, bridges, inlays, and onlays is limited to once every year.
          </div>
        </div>
      </app-card-container>
    </div>
  </div>
  <div class="row mt-5 mb-4" *ngIf="em.legalLanguage.adminBy == 'caregington'">
    <div class="col-12 col-lg-12">
      <app-card-container>
        <div class="row mb-3">
          <div class="col-12">
            <div class="header-text">Additional Member Savings</div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-lg-12">
            Just $30 per person to add additional family members onto your plan
          </div>
        </div>
      </app-card-container>
    </div>
  </div>
  <app-exclusions [details]="details"></app-exclusions>
</div>
<app-legal-text [officeData]="officeData"></app-legal-text>
